'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function AbstractElement(_ref) {
  var children = _ref.children,
      tagName = _ref.tagName,
      rest = _objectWithoutProperties(_ref, ['children', 'tagName']);

  var Tag = tagName;
  return _react2.default.createElement(
    Tag,
    rest,
    children
  );
}

AbstractElement.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  tagName: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]).isRequired
};

AbstractElement.defaultProps = {
  tagName: 'span'
};

AbstractElement.displayName = 'AbstractElement';

exports.default = AbstractElement;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/elements/AbstractElement.js
// module id = 360
// module chunks = 0